import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Clothes } from 'src/app/models/Clothes';
import { Family } from 'src/app/models/Family';
import { ReportOrder } from 'src/app/models/ReportOrder';
import { ResponseReportStore } from 'src/app/models/ResponseReportStore';
import { SearchReport } from 'src/app/models/SearchReport';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ClothesService } from 'src/app/services/clothes.service';
import { FamilyService } from 'src/app/services/family.service';
import { ReportService } from 'src/app/services/report.service';
import { CONSTANTES, getToken } from 'src/app/shared/global';
declare var jQuery: any;


@Component({
  selector: 'app-store-movement-report',
  templateUrl: './store-movement-report.component.html',
  styleUrls: ['./store-movement-report.component.scss']
})
export class StoreMovementReportComponent implements OnInit {
  
  public clothes: Clothes[]=[];  
  public families: Family[] = [];
  public subFamilies: Family[] = [];
  public familySelect: string;
  public clothSelected: string;
  public subFamilySelect: string;
  public typeSelect:String[]= [];
  public clothSelect:String[]= [];
  public subFamiliesSelect: String[]=[];
  public period : Date;
  public dateFromSelect: Date;
  public dateToSelect: Date;
  public searchReport: SearchReport;
  public reportOrder : ReportOrder;
  public search : boolean = false;
  displayedColumns: string[] = ['dateTracking','noc','cloth','size','amount'];
  types: String[] = ['ENTRADA','SALIDA'];
  form: FormGroup;
  public total: number=0;

  public dataSource : MatTableDataSource<ResponseReportStore>;

  public dataTotal: ResponseReportStore [] = [];
  
  @ViewChild(MatSort) sort: MatSort;

  constructor( private reportService : ReportService,private clothesService: ClothesService, private spinner: NgxSpinnerService,private toastr: ToastrService, 
    private authService: AuthenticationService,private router: Router, private familyService: FamilyService) { }

  ngOnInit() {
    this.spinner.show();
    try{
      jQuery.getScript(CONSTANTES.menu);
    } catch(Error){
      this.router.navigate(['login']);
    }
    this.loadFamilies();

    this.form = new FormGroup({
      'family': new FormControl('', Validators.required),
      'subFamily': new FormControl('', Validators.required),
      'cloth': new FormControl('', Validators.required),
      'dateFrom': new FormControl('', Validators.required),
      'dateTo': new FormControl('', Validators.required),
      'types': new FormControl('', Validators.required),
    });
    this.spinner.hide();
  }
  
  /**Obtiene las familias */
  loadFamilies() {
    this.spinner.show();
    this.familyService.getAll().subscribe(
      data => {
        if (getToken(data)) {
          for (let i = 0; i < data.families.length; i++) { 
             if(data.families[i].parent === null){
                this.families.push(data.families[i]);
             } else {
                this.subFamilies.push(data.families[i]);
             }
          }
        }
      },
      error => {
        this.spinner.hide();
        this.toastr.error("HA OCURRIDO UN ERROR AL CARGAR LOS DATOS", "ERROR");
      }
    )
    this.spinner.hide();
  }

  /**Obtiene las subfamilias de la familia seleccionada */
  getSubfamilies() {
    this.spinner.show();
    this.subFamiliesSelect = [];
    this.subFamiliesSelect.push('');
    for (let i = 0; i < this.subFamilies.length; i++) {
      if (this.subFamilies[i].parent.name === this.familySelect) {
        this.subFamiliesSelect.push(this.subFamilies[i].name);
      }
    }
    this.spinner.hide();
  }

  /**Obtiene las prendas de la subfamilia o familia seleccionada */
  loadClothesFamily() {
    this.spinner.show();

    let data = new Family();
    data.parent = new Family();
    data.parent.name = this.familySelect.toString();
    data.name = this.subFamilySelect.toString();
        
    this.clothes = [];
    this.clothSelect = [];
    this.clothesService.getClothesByFamily(data).subscribe(
      data => {
        if (getToken(data)) {
          if (data.clothes != null) {
            this.clothes = data.clothes;
            this.clothSelect.push('');
            for (let i = 0; i < data.clothes.length; i++) {
              if (this.clothes[i].name != null)
                this.clothSelect.push(this.clothes[i].name);
            }
          } else {
            this.toastr.error("LA FAMILIA NO TIENE PRENDAS ASIGNADAS");
            this.spinner.hide();
          }
        }
        this.spinner.hide();
      }, error => {
        this.toastr.error(error);
        this.logOut();
      }
    );
  }

  loadReport() {

    let reportOrder = new ReportOrder();
    reportOrder.searchReport = new SearchReport();

    if (this.typeSelect != null && this.typeSelect.length > 0) {
      reportOrder.searchReport.type = this.typeSelect.toString();
      if (this.familySelect != null && this.familySelect.length > 0) {
        reportOrder.searchReport.family = this.familySelect;
      } else {
        reportOrder.searchReport.family = null;
      }
      if (this.subFamilySelect != null && this.subFamilySelect.length > 0) {
        reportOrder.searchReport.subFamily = this.subFamilySelect;
      } else {
        reportOrder.searchReport.subFamily = null;
      }

      if (this.clothSelected != null && this.clothSelected.length > 0) {
        reportOrder.searchReport.clothes = this.clothSelected.toString();
      } else {
        reportOrder.searchReport.clothes = null;
      }

      if (this.dateFromSelect != null && this.dateToSelect != null) {
        reportOrder.searchReport.toDate = this.dateToSelect;
        reportOrder.searchReport.fromDate = this.dateFromSelect;
      } else {
        reportOrder.searchReport.toDate = null;
        reportOrder.searchReport.fromDate = null;
      }

      if ((this.dateFromSelect != null && this.dateToSelect != null) && (this.dateFromSelect == this.dateToSelect)) {
        this.toastr.info("NO PUEDEN COINCIDIR LAS FECHAS");
      }
      else if (this.dateFromSelect > this.dateToSelect) {
        this.toastr.info("LA FECHA DE FIN NO PUEDE SER ANTERIOR A LA INCIO");
      }
      else if ((this.dateToSelect == null && this.dateFromSelect != null) || (this.dateToSelect != null && this.dateFromSelect == null)) {
        this.toastr.info("DEBE RELLENAR EL PERIODO DE MANERA COMPLETA");
      } else {
        this.search = false;
        this.spinner.show();
          this.reportService.getReportStore(reportOrder).subscribe(
            data => {
              if (getToken(data)) {
                if (data.responseReportStore === null || data.responseReportStore.length === 0) {
                  this.search = false;
                  this.toastr.info("NO EXISTEN DATOS PARA MOSTRAR", "INFO");
                } else {
                  this.search = true;
                  this.dataTotal = data.responseReportStore;
                  this.dataSource = new MatTableDataSource(data.responseReportStore);
                  this.dataSource.sort = this.sort;
                }
              }
              this.spinner.hide();
            }, error => {
              this.toastr.error(error);
              this.logOut();
            }
          );
      }
    } else {
      this.toastr.info("DEBE RELLENAR EL TIPO OBLIGATORIAMENTE");
    }
  }
  
  logOut() {
    let infoUser = {
      userName: localStorage.getItem("nid")
    }
    this.authService.logOut(infoUser).subscribe(
      data => {
        localStorage.clear();
        this.router.navigate(['login']);
      }
    );
  }

  getTotalCost() {
    this.total = 0;
    this.dataTotal.forEach(element => {
      this.total += Number(element.amount);
    });
    return this.total;
  }

}
